<template>
  <div class="animalBtn">
    <div class="cn nowrap">{{cnTitle}}</div>
    <div class="en nowrap" v-html="enTitle"></div>
  </div>
</template>

<script>
export default {
  props: {
    cnTitle: {
      type: String,
      default: ''
    },
    enTitle: {
      type: String,
      default: ''
    },
  },
}
</script>

<style lang="stylus" scoped>
.animalBtn
  // width 194px
  height 78px
  // padding-top 15px
  box-sizing border-box
  border 2px solid #fefdd9
  background #99be70
  border-radius 15px
  color #3d3126
  text-align center
  margin 15px 15px 0 0
  cursor pointer
  transition .3s
  padding 15px 8px 5px
  box-sizing border-box
  &:hover
    transform scale(1.1)
  .cn
    font 30px/1 'FZQKBYSJW GB1 0'
  .en
    margin-top 5px
    font 12px/1 'FZQKBYSJW GB1 0'
</style>